import { useQContent } from '@exam-management/common/qcontent-provider';
import { TagCategory } from '@exam-management/qbs-provider';
import {
  BarChartIcon,
  Box,
  Flex,
  IconButton,
  ReadonlyField,
  styled,
  Text,
} from '@shared/components';
import { useDisclosure } from '@shared/hooks';

import { DEFAULT_CRITERIA, DifficultyText } from '../../components';
import { getDifficultyCriteria } from '../../utils';
import { PUseHistoryModal } from '../p-use-history-modal';

import { VIEWABLE_P_USE_STATUSES, VIEWABLE_B_INDEX_STATUSES } from './constants';

function NoInformationText() {
  return <Text color='textDisabled'>ยังไม่มีข้อมูล</Text>;
}

const FieldWrapper = styled(Box)({ flex: 1 });

export default function InformationView() {
  const { qContent } = useQContent();

  const calculation = qContent.tags.find((tag) => tag.category === TagCategory.Calculation);
  // NOTE: Since we had view and form state, if criteria in change someday
  // Don't forget to change at PValueField component too (They got a value from a form)
  const currentCriteria = getDifficultyCriteria(DEFAULT_CRITERIA, qContent.pValue);
  const shouldDisplayPUse = VIEWABLE_P_USE_STATUSES.includes(qContent.status);
  const shouldDisplayBIndex = VIEWABLE_B_INDEX_STATUSES.includes(qContent.status);

  const [isOpen, { open, close }] = useDisclosure();

  return (
    <>
      <Flex sx={{ gap: (theme) => theme.spacing(6) }}>
        <FieldWrapper>
          <ReadonlyField
            label='ประเภทข้อสอบ'
            content={
              <Text color={calculation?.name ? 'textPrimary' : 'textDisabled'}>
                {calculation?.name ?? 'ยังไม่มีข้อมูล'}
              </Text>
            }
          />
        </FieldWrapper>
        <FieldWrapper>
          <ReadonlyField
            label='ค่า P Initial'
            content={
              typeof qContent.pInitial === 'number' ? (
                <Flex sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
                  <Text>{qContent.pInitial.toFixed(2)}</Text>
                  <DifficultyText criteria={currentCriteria} />
                </Flex>
              ) : (
                <NoInformationText />
              )
            }
          />
        </FieldWrapper>
        {shouldDisplayPUse ? (
          <Flex
            sx={{
              alignItems: 'flex-end',
              justifyContent: 'center',
              minWidth: '254px',
            }}
          >
            <ReadonlyField
              label='ค่า P Used'
              content={
                typeof qContent.pValue === 'number' ? (
                  <Flex sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
                    <Text>{qContent.pValue.toFixed(2)}</Text>
                    <DifficultyText criteria={currentCriteria} />
                  </Flex>
                ) : (
                  <NoInformationText />
                )
              }
            />
            <Flex
              sx={(theme) => ({
                p: theme.spacing(2),
              })}
            >
              <IconButton onClick={open}>
                <BarChartIcon
                  sx={(theme) => ({
                    fontSize: '28px',
                    color: theme.palette.text.disabled,
                  })}
                />
              </IconButton>
            </Flex>
          </Flex>
        ) : null}
        {shouldDisplayBIndex ? (
          <FieldWrapper>
            <ReadonlyField
              label='ค่า B-Index'
              content={
                qContent.bIndexValue ? <Text>{qContent.bIndexValue}</Text> : <NoInformationText />
              }
            />
          </FieldWrapper>
        ) : null}
      </Flex>
      <PUseHistoryModal open={isOpen} onClose={close} />
    </>
  );
}
